import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";


const useStandardTroopScheduleSteps = () => {
    const location = useLocation();
    const { axios_helper_no_header } = useAxios();
    const { MEDICARE_STANDARD_TROOP_SCHEDULE_STEPS_DETAIL } = ROUTE_PATHS;

    const stateVal = location.state;
    const [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    console.log("current state in form", currentState, previousState);

    const {
        selectedSchedules = [],
        selectedCodesListItem = "",
        previousScreen = "",
        currentIndex: initialIndex = 0,
        currentYear = 0,
        recordYear = 0,
        selectMode = false,
        paramsData: initialParamsData = {
            sbsScheduleName: selectedSchedules[initialIndex].sbsScheduleName,
            sbsScheduleDesc: selectedSchedules[initialIndex].sbsScheduleDesc,
        },
    } = currentState;
    const [data, setData] = useState([]); /* Standard Troop Schedule Steps Data */
    const [paramsData, setParamsData] = useState(initialParamsData);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [rowData, setRowData] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);
    const navigateToPage = useCustomNavigate();
    const [dropdownValues, setDropdownValues] = useState({});
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState("no");
    const toast = useToast();

    const [currentIndex, setCurrentIndex] = useState(initialIndex)
    const screen_title = "Standard TrOOP Schedule Steps";
    const screenNumber = "RCSBD001";

    /* Search form fields that needs to be shown for filtering */
    const formFields = [
        {
            fieldLabel: "Schedule",
            name: "sbsScheduleName",
            label: "Schedule",
            type: "text",
            fieldNature: "readOnly",
            value: "",
            maxLength: 10,
        },
        {
            fieldLabel: "Description",
            name: "sbsScheduleDesc",
            label: "Description",
            type: "text",
            fieldNature: "readOnly",
            value: "",
            maxLength: 25,
        },
    ];

    /* Dropdown options fields that needs to be fetched with API */
    const dropdownOptions = [];

    const dropdownCondition = {
        dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
    };

    const handleBack = useCallback(() => {
        if (currentIndex < selectedSchedules.length - 1) {
            setCurrentIndex(currentIndex + 1);
        } else {
            const lastScheduleName =
      selectedSchedules[currentIndex]?.sbsScheduleName || "";
    const updatedParamsData = {
      ...currentState.paramsData,
      sbsScheduleName: lastScheduleName,
    };
      navigateToPage(previousScreen, [
        ...previousState,
        {
          paramsData: updatedParamsData,
          currentIndex: currentIndex,
        },
      ]);
    }
  }, [currentIndex, selectedSchedules]);

    const leftButtons = [{ button_label: 'Back', button_handeler: handleBack, button_key: "F12" }];

    /* ACTION BUTTONS info that needs to be displayed on the page */
    const ctaButtons = [
        {
            button_label: "Export as CSV",
            button_handeler: () => {
                exportAsCSV();
            },
            button_key: "",
        }
    ];

    /* Gear Icon Menu option CTAs */
    const menuOptions = [
        {
            label: "Display",
            icon: <span className="material-icons">visibility</span>,
            command: () => {
                navigateToPage(MEDICARE_STANDARD_TROOP_SCHEDULE_STEPS_DETAIL, [...previousState, { ...currentState, currentIndex },{
                    selectedSchedules: [selectedSchedules[currentIndex]],
                    selectedSteps: selectedRows.length ? selectedRows : [rowData],
                    previousScreen: location.pathname,
                }]);
            },
        }
    ];

    /* Data table column info. */
    const columnDef = [
        {
            header: "Coverage Level",
            field: "sbdCoverageLevel",
        },
        {
            header: "TrOOP Amount",
            field: "sbdTroopAmount",
        },
        ...(recordYear < currentYear + 1 ? [{  
            header: "Drug Spend",  
            field: "sbdDrugSpend",  
        }] : []) 
    ];

    /* Param Key which used as bridge between various operations on tabluar data */
    const parmKey = "sbdStepNumber";

    /* Handler that fetches the data */
    const fetchData = async () => {
        const page = first / rows;
        try {
            const raw_response = await axios_helper_no_header("GET", `api/sbdStdBrandDiscDetail`, null, {
                page: page,
                size: rows,
                ...paramsData,
                sbdStepNumber: rowData[parmKey]
            });
            const response = raw_response.responseData;
            const pageResponse = raw_response.responsePaginationDTO;
            if (response.length === 0) {
                setData([]);
                setTotalRecords(0);
                toast.current.show({
                    severity: "info",
                    summary: "",
                    detail: response.responseStatus.message,
                    life: 3000,
                });
            } else {
                setData(response);
                setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords  
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setData([]);
            setTotalRecords(0);
        }
    };

    const fetchDropdownData = async (dataDropdown) => {
        try {
            const response = await fetchDropdownValues(dataDropdown);
            setDropdownValues(response);
        } catch (error) {
            console.error("Error fetching dropdown values:", error);
        }
    };

    useEffect(() => {
        fetchDropdownData(dropdownCondition);
    }, []);

    useEffect(() => {
        fetchData(); // Initial fetch with page 0 and page size 10  
    }, [paramsData, rows, currentPage, selectedOption]);

    useEffect(()=>{
        if(currentIndex!=initialIndex){
          setParamsData({
            sbsScheduleName: selectedSchedules[currentIndex].sbsScheduleName,
            sbsScheduleDesc: selectedSchedules[currentIndex].sbsScheduleDesc,
        });
        }
      },[currentIndex]);

    const onPageChange = (event) => {
        console.log("page change", event.first, event);
        setFirst(event.first);
        setCurrentPage(event.page);
        setRows(event.rows);
    };

    const openConfirmationModal = () => {
        setIsConfirmationModalOpen(true);
    };

    const closeConfirmationModal = () => {
        console.log(selectedOption);
        setIsConfirmationModalOpen(false);
        setSelectedOption("no");
    };

    const exportAsCSV = async () => {
        const queryParams = new URLSearchParams({
            ...paramsData,
            sbdStepNumber: rowData[parmKey]
        });
        try {
          const response = await axios_helper_no_header(
            "GET",
            "api/sbdStdBrandDiscDetail/exportCsv",
            null,
            queryParams,
            "blob"
          );
          downloadCSV(response);
        } catch (error) {
          console.error("Error exporting as CSV:", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: "Failed to export CSV. Please try again.",
            life: 3000,
          });
        }
      };

    const updateParamData = (data) => {
        setFirst(0);
        setCurrentPage(0);
        setParamsData(data);
    };

    return {
        screenNumber,
        screen_title,
        formFields,
        dropdownValues,
        paramsData,
        updateParamData,
        ctaButtons,
        leftButtons,
        data,
        parmKey,
        menuOptions,
        columnDef,
        setRowData,
        selectedRows,
        setSelectedRows,
        first,
        rows,
        totalRecords,
        currentPage,
        onPageChange,
        isConfirmationModalOpen,
        closeConfirmationModal,
        setSelectedOption,
    };
};

export default useStandardTroopScheduleSteps;  